export function addSceneMethods(pViewer){

    pViewer.scene.scene.getObjectsByProperty = (property, value) => {

        let objects = [];

        this.threeScene.traverse((obj) => {
            if (obj[property] === value) {
                objects.push(obj)
            }
        })
        
        return objects;

    }

    let originalAddMethod = pViewer.scene.scene.add;

    pViewer.scene.scene.add = function(...objects) {

        originalAddMethod.apply(this, objects);
        objects.forEach((obj) => {
            obj.designOwner = 'potree';
        })

    }

}